module.exports = __webpack_public_path__ + "static/media/profile-anrizqa.d24a7ffd.jpeg";